<template>
  <div class="wrapper">
    <div class="title-top">
      <i class="iconfont iconarrowRight-copy" @click="$router.go(-1)"></i>
      <span>订单确认</span>
    </div>

    <div class="order">
      <!-- <div class="title">
                <div>{{ order.order_no }}</div>
                <div>{{ order.create_time }}</div>
            </div> -->

      <div class="content">
        <div
          v-for="item in order.goods_list"
          :key="item.goods_id"
          class="content-item"
        >
          <img :src="item.image[0].file_path" alt="" class="img" />
          <div class="info">
            <div class="name">{{ item.goods_name }}</div>
            <div class="material">
              <span>产品编号:</span>{{ item.sku[0].goods_no }}
            </div>
            <div class="material">
              <span>材质:</span> {{ item.sku[0].material }}
              <div style="display:inline" v-if="item.sku[0].goods_size">
                <span style="margin-left: 20px">尺寸:</span>
                {{ item.sku[0].goods_size }}cm
              </div>
            </div>
            <div class="material">
              <span>克重(g):</span>
              {{ item.sku[0].goods_weight }}
            </div>
            <!-- <div class="material" v-if="userType">
              <span>销售工费：</span>{{ item.sku[0].goods_sell_wage }}
              <span style="margin-left: 20px">销售附加工费：</span
              >{{ item.sku[0].goods_add_sell_wage }}
            </div> -->
            <!-- <div class="goods_price">
                            <span>￥</span>{{ item.total_price }}
                        </div> -->
          </div>
          <div class="total-num">
            ×{{ item.total_num }}
            <div v-if="Mobile">
              <van-cell-group>
                <van-field
                  :border="border"
                  v-model="item.lettering"
                  maxlength="8"
                  label="刻字要求:"
                  placeholder="请输入刻字要求(8字内)"
                />
                <van-field
                  :border="border"
                  v-model="item.goods_remark"
                  :maxlength="50"
                  label="备注:"
                  placeholder="请输入想备注的内容"
                />
              </van-cell-group>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="customer" v-if="Mobile">
      <p>客户信息填写</p>
      <van-cell-group style="display: flex">
        <van-field
          :border="border"
          style="margin-right: 7px"
          v-model="customer_name"
          label="客户姓名:"
          placeholder="请输入客户姓名"
        />
        <van-field
          :border="border"
          v-model="customer_phone"
          type="number"
          maxlength="11"
          label="客户手机:"
          placeholder="请输入客户手机号"
        />
      </van-cell-group>
    </div>
    <div v-if="order" class="down">
      <span
        >总重量预估(g):
        <span class="totle_weight">{{ totle_weight }}</span>
        <span style="margin-left:10px">总件数：</span>
        <span class="totle_weight">{{ total_num }}件</span>
      </span>
      <div class="signature" @click="sign">
        {{ isEmpty ? "已签名" : "签名" }}
      </div>
      <van-popup v-model="show" :close-on-click-overlay="false" :round="true">
        <div class="container">
          <VueSignaturePad
            id="signature"
            height="4.5rem"
            ref="signaturePad"
            :options="options"
          />
        </div>
        <div class="buttons">
          <div class="left">
            <div style="margin-right:30px;" class="sconfirm" @click="save">
              确认
            </div>
            <div class="sconfirm" @click="show = false">取消</div>
          </div>
          <div class="sremove" @click="undo">清除</div>
        </div>
      </van-popup>
      <div class="btn" @click="handleOrder">提交订单</div>
      <!-- <span style="margin-left: 30px">合计：</span>￥{{
                    order.total_price
                }} -->
    </div>
  </div>
</template>

<script>
import {
  orderCardDetail,
  cardOrder,
  shoppCarList,
  upSignature,
  qiniuToken,
  getCategoryChild
} from "../../api/http.js";
import Vue from "vue";
import { Toast } from "vant";
import $ from "jquery";
import { error } from "three";
Vue.use(Toast);
export default {
  data() {
    return {
      userType: null,
      order: "",
      totle_weight: "",
      cart_ids: "",
      Mobile: null,
      lettering: "",
      goods_remark: "",
      customer_name: "",
      customer_phone: "",
      border: false,
      total_num: 0,
      show: false,
      options: {
        penColor: "#000"
      },
      isEmpty: false,
      base: "",
      qiniu: "",
      domain: ""
    };
  },
  created() {
    if (localStorage.getItem("user_type") == "wholesaler_user") {
      this.userType = false;
    } else {
      this.userType = true;
    }
    let token = localStorage.getItem("login_token");
    this.cart_ids = this.$route.query.ids;
    orderCardDetail(this.cart_ids, token).then(res => {
      console.log(res);
      this.order = res.data;
      if (this.order.goods_list.length === 1) {
        this.totle_weight = (
          this.order.goods_list[0].sku[0].goods_weight *
          this.order.goods_list[0].total_num
        ).toFixed(2);
      } else {
        let weightArr = this.order.goods_list.map(ele => {
          return Number((ele.sku[0].goods_weight * ele.total_num).toFixed(2));
        });
        let weight = weightArr.reduce(function(a, b) {
          return a + b;
          1;
        });
        this.totle_weight = weight.toFixed(2);
      }
      console.log(this.order);
      this.order.goods_list.map(item => {
        this.total_num += item.total_num * 1;
        console.log(this.total_num);
      });
    });
    this.isMobile();
  },
  methods: {
    sign() {
      this.show = true;
      if (!this.Mobile) {
        this.$nextTick(() => {
          $(".down")
            .children(".van-popup")
            .css({
              height: "4rem",
              top: "54%"
            });
          $("#signature").css({
            overflow: "hidden",
            height: "3rem"
          });
        });
      }
    },
    undo() {
      const { data } = this.$refs.signaturePad.saveSignature();
      this.$refs.signaturePad.clearSignature();
      this.isEmpty = false;
      console.log(this.isEmpty);
      this.base = data;
    },
    save() {
      let token = localStorage.getItem("login_token");
      const { isEmpty, data } = this.$refs.signaturePad.saveSignature();
      if (isEmpty) {
        Toast("请签名");
      } else {
        this.base = data;
        this.base = this.base.slice(this.base.indexOf(",") + 1); //处理base64
        //获取七牛token
        qiniuToken(token).then(res => {
          this.qiniu = res.data.token;
          this.domain = res.data.domain;
          let size = this.dataURLtoBlob(data).size;
          var pic = this.base; //base64w
          var url = `https://upload-z2.qiniup.com/putb64/${size}`;
          var xhr = new XMLHttpRequest();
          xhr.onreadystatechange = () => {
            if (xhr.readyState == 4) {
              let text = JSON.parse(xhr.responseText);
              this.domain += `/${text.hash}`;
              this.isEmpty = true;
            }
          };
          xhr.open("POST", url, true);
          xhr.setRequestHeader("Content-Type", "application/octet-stream");
          xhr.setRequestHeader("Authorization", "UpToken " + this.qiniu);
          xhr.send(pic);
        });
        console.log("已签名");
        this.show = false;
      }
    },

    dataURLtoBlob(dataurl) {
      var arr = dataurl.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new Blob([u8arr], { type: mime });
    },

    isMobile() {
      if (screen.height == 1080 && screen.width == 1920) {
        return (this.Mobile = false); // PC端
      } else {
        return (this.Mobile = true); //移动端
      }
    },
    handleOrder() {
      if (this.isEmpty) {
        let token = localStorage.getItem("login_token");
        let letteringObj = [];
        let remarkArr = [];
        this.order.goods_list.forEach(ele => {
          if (ele.lettering) {
            letteringObj.push(ele.lettering);
          } else {
            letteringObj.push("");
          }

          if (ele.goods_remark) {
            remarkArr.push(ele.goods_remark);
          } else {
            remarkArr.push("");
          }
        });
        cardOrder(
          this.cart_ids,
          token,
          letteringObj.toString(),
          remarkArr.toString(),
          // this.lettering,
          // this.goods_remark,
          this.customer_phone,
          this.customer_name,
          this.domain //签名
        ).then(res => {
          this.$toast("下单成功");
          shoppCarList(token).then(res => {
            this.$store.commit("cart", res.data.goods_list.length);
          });
          this.$router.replace("/orderList");
        });
      } else {
        this.$toast("请签名");
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.wrapper {
  background-color: #e3e1e1;
  padding-top: 44px;
  padding-bottom: 60px;
  height: 100vh;
  overflow-y: scroll;
  .title-top {
    position: fixed;
    top: 0;
    left: 0;
    height: 44px;
    z-index: 9999;
    width: 100%;
    background-color: #fff;
    text-align: center;
    line-height: 44px;
    font-size: 16px;
    .iconfont {
      position: absolute;
      left: 2%;
      top: 50%;
      transform: translateY(-50%);
    }
  }
  .order {
    background-color: #fff;
    margin-top: 6px;
    padding: 13px;
    .title {
      font-size: 12px;
      display: flex;
      height: 30px;
      justify-content: space-between;
      border-bottom: 1px solid #f1f1f1;
    }

    .content {
      .content-item {
        display: flex;
        padding: 6px 0;
        position: relative;
        border-bottom: 1px solid #f1f1f1;

        .img {
          background: #000;
          width: 120px;
          height: 120px;
          border-radius: 4px;
          margin-right: 18px;
        }
        .total-num {
          text-align: right;
          font-size: 13px;
          position: absolute;
          right: 33px;
          top: 30px;
        }
        .info {
          color: #191919;
          font-size: 13px;
          font-weight: 400;
          .name {
            font-weight: 600;
            margin-bottom: 10px;
          }
          .material {
            margin-bottom: 9px;

            span {
              color: #747474;
            }
          }
          .goods_price {
            font-size: 16px;
            span {
              font-size: 12px;
            }
          }
          .user_phone {
            margin-top: 12px;
            span {
              color: #747474;
            }
          }
        }
      }
    }
  }
  .down {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 60px;
    background-color: #fff;
    font-size: 14px;
    color: #000;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 20px;
    box-sizing: border-box;
    span {
      color: #8b8b8b;
      .totle_weight {
        color: #000;
      }
    }
    .signature {
      width: 128px;
      height: 40px;
      line-height: 40px;
      text-align: center;
      background-color: #090808;
      color: #fff;
      border-radius: 5px;
      position: absolute;
      right: 170px;
    }
    .btn {
      width: 128px;
      height: 40px;
      line-height: 40px;
      text-align: center;
      background-color: #090808;
      color: #fff;
      border-radius: 5px;
    }
  }
}
</style>
<style lang="scss">
.down .van-popup {
  width: 1000px;
  height: 550px;
  box-sizing: border-box;
  padding: 20px 20px 0;
  display: flex;
  flex-direction: column;
  #signature {
    // height: 450px;
    // border: 3px solid #000;
    background: #eee;

    // margin-bottom: 15px;
    // margin: 30px auto;
  }
  canvas {
    // height: 450px;
  }
  .buttons {
    display: flex;
    flex: 1;
    justify-content: space-around;
    align-items: center;
    .left {
      display: flex;
    }
    .sconfirm,
    .sremove {
      font-size: 15px;
      width: 128px;
      height: 40px;
      line-height: 40px;
      text-align: center;
      background-color: #090808;
      color: #fff;
      border-radius: 5px;
    }
    .sremove {
      position: absolute;
      right: 20px;
      width: 80px;
      height: 40px;
    }
  }
}
.van-hairline--top-bottom::after {
  border-width: 0 !important;
}
.total-num {
  .van-cell {
    margin-bottom: 6px;
    font-size: 12px;
    padding: 0;
    height: 30px;
    color: #8b8b8b;
    .van-cell__value {
      min-width: 257px;
      max-width: 257px;
    }
    .van-field__label {
      text-align: right;
      max-width: 200px;
      margin-right: 6px;
      line-height: 30px;
    }
    .van-field__body {
      input {
        min-width: 257px;
        height: 30px;
        background: #f1f1f1;
        text-indent: 14px;
        margin-left: 6px;
      }
    }
  }
}
.customer {
  .van-hairline--top-bottom {
    height: 48px !important;
  }
  position: relative;
  background: #fff;
  height: 50px;
  display: flex;
  justify-content: space-between;
  p {
    line-height: 30px;
    width: 200px;
    margin: 0;
    font-size: 12px;
    margin-left: 13px;
  }
  .van-cell-group {
    flex: 1;
    // position: absolute;
    // right: 46px;
    // top: 0;
    margin-right: 45px;
    margin-left: 55px;

    .van-cell {
      padding: 0;
    }
    .van-field__label {
      text-align: right;
      color: #8b8b8b;
      font-size: 12px;
      margin-right: 10px;
      line-height: 30px;
      margin-bottom: 10px;
    }

    input {
      min-width: 257px;
      height: 30px;
      background: #f1f1f1 !important;
      font-size: 12px;
      text-indent: 14px;
    }
  }
}
</style>
